import React, { createContext, useContext, useState } from 'react';

const SidePanelContext = createContext(null);

export function SidePanelProvider({ children }) {
  const [ticker, setTicker] = useState(null); // { name, sector, ... }

  const open  = (t) => setTicker(t);
  const close = ()  => setTicker(null);

  return (
    <SidePanelContext.Provider value={{ ticker, open, close }}>
      {children}
    </SidePanelContext.Provider>
  );
}

export const useSidePanel = () => useContext(SidePanelContext);
